const LOCALE = {
    LOCALES: ['lt', 'en', 'ru', 'pl'],
    DEFAULT_LOCALE: 'en',
};
export default LOCALE;
